import styled, { StyledProps } from 'styled-components'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import { EModOrientation, IModOrientation } from '@ucheba/utils/helpers/styles/mod.types'
import { IModImgView } from '../types'

const Image = styled.div<StyledProps<IModOrientation & IModImgView>>`
  position: absolute;
  bottom: 0;
  top: 0;
  right: 0;
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: cover;

  ${sm.mod(EModOrientation.vertical)`
    background-size: 100%;
    width: 100% !important;
  `};
`

const Content = styled.div<StyledProps<IModOrientation & IModImgView>>`
  position: relative;
  z-index: 1;

  ${sm.mod(EModOrientation.vertical)`
    max-width: 100% !important;
  `};
`

const Block = styled.div<StyledProps<IModOrientation>>`
  display: flex;
  justify-content: space-between;
  position: relative;
  overflow: hidden;

  ${sm.mod(EModOrientation.vertical)`
    flex-direction: column;
    align-items: center;
  `};
`

export default { Block, Content, Image }
